import request from '@/utils/ai-train-request'

// AI训战 - 评分表（ai_scene_score_item，挂在场景下：group_type 1基础(合计≤80)/2难度(系统按难度自动生成，不可编辑)）
const apiPath = '/admin/scene'

const aiTrainScoreTemplateApi = {
  fetchList(sceneId) {
    return request({ url: `${apiPath}/${sceneId}/score-items`, method: 'get' })
  },
  /**
   * 整表保存（后端仍需按任务书 §4.2 校验：group_type=1 合计不超过 80，
   * 前端只是先拦一道，别把校验完全交给后端）
   */
  save(sceneId, items) {
    return request({ url: `${apiPath}/${sceneId}/score-items`, method: 'put', data: { items } })
  }
}

export default aiTrainScoreTemplateApi
